// Long-lived-tab update nudge. The SW serves navigations network-first, so a
// RELOAD always gets the newest build - but webmail tabs (and the installed
// PWA) stay open for days and never navigate, so deployed fixes never reach
// them. This polls the entry HTML occasionally; when the built entry script no
// longer matches the one this tab booted with, it shows a small banner whose
// button reloads the app. No auto-reload: never yank a half-written draft.

import { network } from "./cache/net.js";

const CHECK_EVERY_MS = 30 * 60 * 1000;  // 30 min - one tiny HTML fetch
let bannerShown = false;

function currentEntrySrc() {
  const el = document.querySelector('script[type="module"][src*="/assets/"]');
  return el?.getAttribute("src") ?? null;
}

async function newBuildAvailable() {
  const mine = currentEntrySrc();
  if (!mine) return false;
  try {
    const res = await fetch("/index.html", { cache: "no-store" });
    if (!res.ok) return false;
    const html = await res.text();
    return !html.includes(mine);
  } catch { return false; }
}

function showBanner() {
  if (bannerShown) return;
  bannerShown = true;
  const bar = document.createElement("div");
  bar.id = "mc-update-banner";
  bar.style.cssText = "position:fixed;bottom:16px;left:50%;transform:translateX(-50%);z-index:9999;"
    + "display:flex;align-items:center;gap:12px;padding:10px 16px;border-radius:999px;"
    + "background:#202124;color:#fff;font-size:13px;box-shadow:0 4px 16px rgba(0,0,0,.25);";
  bar.innerHTML = `
    <span>A new version of McMail is available.</span>
    <button id="mc-update-now" style="padding:6px 14px;border:0;border-radius:999px;background:#e34234;
      color:#fff;font-size:12.5px;font-weight:600;cursor:pointer;">Update</button>
    <button id="mc-update-later" style="background:none;border:0;color:#9aa0a6;font-size:12.5px;
      cursor:pointer;">Later</button>`;
  document.body.appendChild(bar);
  bar.querySelector("#mc-update-now").onclick = () => window.location.reload();
  bar.querySelector("#mc-update-later").onclick = () => { bar.remove(); bannerShown = false; };
}

async function check() {
  if (!network.isOnline()) return;
  if (document.visibilityState !== "visible") return;
  if (await newBuildAvailable()) showBanner();
}

export function startUpdateCheck() {
  setInterval(() => { void check(); }, CHECK_EVERY_MS);
  // Also check when the user comes back to the tab - the common moment a
  // days-old tab resurfaces.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") setTimeout(() => { void check(); }, 3000);
  });
}
